import PageLayout from "../components/pageLayout";
import UserProfile from "../components/UserProfile";

export default function UserProfilePage() {
    return (
        <PageLayout children={<UserProfile />} />
    )
}
